import { LinearProgress, Backdrop, Box } from "@mui/material";
import Logo from "../../assets/images/logo-xl.svg";

// ==============================|| LOADER ||============================== //
const Loadable = () => (
    <Backdrop open={true} sx={{ color: "#fff", background: "rgba(0, 62, 101, 1)", zIndex: (theme) => theme.zIndex.drawer + 1000 }}>
        <Box sx={{ width: "30%" }}>
            <img src={Logo} alt="" width="100%" />
            <LinearProgress color="primary" sx={{ mt: 5 }} />
        </Box>
    </Backdrop>
);

export default Loadable;
